const { DEFAULT_MOBILE_PHONE = '0612345678' } = process.env

const formatPhoneNumber = (input) => {
  try {
    const noExt = input.includes('+') ?
      input.split(' ').filter(i => !i.includes('+')).join('') : input
    const noSpace = noExt.replace(' ', '')
    const length = noSpace.length === 10
    const starts = noSpace.match('^(06|07)')
    if (starts && length) {
      return noSpace
    }
    return DEFAULT_MOBILE_PHONE
  } catch (e) {
    return DEFAULT_MOBILE_PHONE
  }
}

module.exports = formatPhoneNumber
